<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small" :style="goodsmaxheight">
          <el-form-item style="width:18%">
          	  <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
          <!--
          <el-form-item style="width:10%">
              <el-select v-model="query.type" placeholder="请选择销售渠道" clearable filterable>
                  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
		  </el-form-item>
          -->
          <el-form-item style="width:10%">
              <el-select v-model="query.goodstype" placeholder="请选择销售商品" clearable filterable @change="ischange=true">
                  <el-option v-for="(item,index) in goodstypelists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
		  </el-form-item>
          <el-form-item style="width:13%">
		      <el-select v-model="query.brandid" filterable clearable placeholder="按品牌"  @change="ischange=true">
		          <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		              <span style="float: left">{{item.name}}</span>
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		          </el-option>
		      </el-select>
	      </el-form-item>
          <el-form-item style="width:10%">
              <el-select v-model="query.clerkid" placeholder="请选择销售员" clearable filterable @change="ischange=true">
                <el-option v-for="(item,index) in clerks" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
		  </el-form-item>
          <el-form-item style="width:10%">
              <el-select v-model="query.sorttype" placeholder="请选择排序类型" @change="ischange=true">
                  <el-option v-for="(item,index) in sorttypelists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
		  </el-form-item>
          <el-form-item style="width:10%">
              <el-select v-model="query.sort" placeholder="排序" @change="ischange=true">
                  <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
		  </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              <el-button type="success" icon="el-icon-download" @click="exportpercentlists">导出</el-button>
              <el-button type="success" size="mini" icon="el-icon-arrow-down" circle @click="showandclosegoods"></el-button>
          </el-form-item>
          <el-form-item>
	          <el-input placeholder="商品名称 / sku" clearable v-model="query.key" @keyup.enter.native="getlists" @change="ischange=true" style="width:100%"></el-input>
	      </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
          <el-table :data="lists" v-loading="percentlistsLoading">
              <el-table-column prop="clerkname" label="销售员名称" align="left"></el-table-column>
              <el-table-column prop="realsales" label="销售金额" align="center" width="180"></el-table-column>
              <el-table-column prop="tcsale" label="提成金额" align="center" width="180"></el-table-column>
              <el-table-column label="操作" align="center" width="120">
                  <template slot-scope="scope">
                      <el-button size="mini" type="primary" icon="el-icon-search" circle @click="showpercentdetail(scope.row)"></el-button>
                  </template>
              </el-table-column>
          </el-table>
          <div class="block">
              <!--分页begin-->
              <el-pagination
                  @size-change="percentlistspageChange"
                  @current-change="percentlistsCurrentChange"
                  :current-page="query.p"
                  :page-sizes="[10, 20, 50]"
                  :page-size="query.rollpage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="rows">
              </el-pagination>
              <!--分页end-->
          </div>
      </div>

      <!---- 导出提成计算信息 ---->
      <el-dialog title="导出提成信息" :visible.sync="percentexportDialog" width="98%" top="5vh">
	      <el-button size="medium" type="danger" @click="exportpercents" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      <div id="outputorder">
		      	<el-table :data="exportlists" border v-loading="percentexportLoading">
		      	  	<el-table-column prop="clerkname" label="销售员名称" align="left"></el-table-column>
                    <el-table-column prop="realsales" label="销售金额" align="center" width="180"></el-table-column>
                    <el-table-column prop="tcsale" label="提成金额" align="center" width="180"></el-table-column>
		      	</el-table>
	      </div>
	      <div slot="footer" class="dialog-footer">
		      <el-button size="medium" @click="percentexportDialog=false">取 消</el-button>
		      <el-button size="medium" type="danger" @click="exportpercents">确认导出</el-button>
		  </div>	                
	  </el-dialog>

      <!-- 销售员月份提成明细 -->
      <el-dialog :title="pclerktitle" :visible.sync="pdetailDialog" width="70%" top="10vh">
	      <el-table :data="pdetaillists" v-loading="pdetailLoading">
              <el-table-column prop="ptime" label="月份" align="left"></el-table-column>
              <el-table-column prop="realsales" label="销售金额" align="center" width="180"></el-table-column>
              <el-table-column prop="tcsale" label="提成金额" align="center" width="180"></el-table-column>
              <el-table-column label="操作" align="center" width="120">
                  <template slot-scope="scope">
                      <el-button size="mini" type="primary" icon="el-icon-search" circle @click="showdetailinfos(scope.row)"></el-button>
                  </template>
              </el-table-column>
          </el-table>
	      <div slot="footer" class="dialog-footer">
		      <el-button size="medium" @click="pdetailDialog=false">取 消</el-button>
		  </div>	                
	  </el-dialog>

      <!-- 提成信息明细 -->
      <el-dialog :title="pclerkinfotitle" :visible.sync="pdetailinfoDialog" width="65%" top="5vh">          
          <div style="float:left;width:100%;text-align:right;">
              <span style="float:right;margin-right:2%">总提成：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{alltc}}</i></span>
              <span style="float:right;margin-right:3%">总销售额：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{allsales}}</i></span>
          </div>

          <el-tag type="danger" style="width:100%;margin-top:10px">温馨提示：提成计算过程中，如有商品同时属于特殊品牌和特殊商品的，按特殊商品的提成计算方式来计算</el-tag>

         
          <!-- 普通提成 -->
          <div style="float:left;width:96%;padding:.5rem 2%;margin-top:20px;border-radius:5px;" v-if="normalnumber>0">              
              <div style="float:left;width:100%;margin-top:20px;margin-bottom:.3rem;border-bottom:1px solid rgb(221,221,221,.7)">
                  <span style="float:left;font-weight:bold">普通提成</span>
                  <span style="float:right">提成：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{normaltc}}</i></span>
                  <span style="float:right;margin-right:3%">销售额：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{normaltotals}}</i></span>
              </div>
              <el-table :data="normallists" v-loading="pdetailinfoLoading">
                    <el-table-column prop="saletotals" label="销售额" align="left"></el-table-column>
                    <el-table-column prop="tc_condition" label="满足提成条件" align="center" width="180"></el-table-column>
                    <el-table-column prop="tc_percent" label="提成比例（%）" align="center" width="180"></el-table-column>
                    <el-table-column prop="tc" label="提成金额" align="center" width="180"></el-table-column>
              </el-table>
          </div>

          <!-- 特殊品牌提成 -->
          <div style="float:left;width:96%;padding:.5rem 2%;margin-top:30px;border-radius:5px;" v-if="brandnumber > 0">
              <div style="float:left;width:100%;margin-bottom:.3rem;border-bottom:1px solid rgb(221,221,221,.7)">
                  <span style="float:left;font-weight:bold">特殊品牌提成</span>
                  <span style="float:right">提成：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{brandtc}}</i></span>
                  <span style="float:right;margin-right:3%">销售额：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{brandtotals}}</i></span>
              </div>
              <el-table :data="brandlists" v-loading="pdetailinfoLoading">
                    <el-table-column prop="valuenames" label="品牌名称" align="left"></el-table-column>
                    <el-table-column prop="saletotals" label="销售额" align="left" width="150"></el-table-column>
                    <el-table-column prop="tc_condition" label="满足提成条件" align="center" width="150"></el-table-column>
                    <el-table-column prop="tc_percent" label="提成比例（%）" align="center" width="150"></el-table-column>
                    <el-table-column prop="tc" label="提成金额" align="center" width="150"></el-table-column>
              </el-table>
          </div>

          <!-- 特殊商品提成 -->
          <div style="float:left;width:96%;padding:.5rem 2%;margin-top:30px;border-radius:5px;" v-if="goodsnumber > 0">
              <div style="float:left;width:100%;margin-bottom:.3rem;border-bottom:1px solid rgb(221,221,221,.7)">
                  <span style="float:left;font-weight:bold">特殊商品提成</span>
                  <span style="float:right">提成：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{goodstotals}}</i></span>
                  <span style="float:right;margin-right:3%">销售额：￥<i style="color:#E6A23C;font-style:normal;font-weight:bold">{{goodstc}}</i></span>
              </div>
              <el-table :data="goodslists" v-loading="pdetailinfoLoading">
                   <el-table-column prop="valuenames" label="商品名称" align="left"></el-table-column>
                    <el-table-column prop="saletotals" label="销售额" align="left" width="150"></el-table-column>
                    <el-table-column prop="tc_condition" label="满足提成条件" align="center" width="150"></el-table-column>
                    <el-table-column prop="tc_percent" label="提成比例（%）" align="center" width="150"></el-table-column>
                    <el-table-column prop="tc" label="提成金额" align="center" width="150"></el-table-column>
              </el-table>
          </div>

	      <div slot="footer" class="dialog-footer">
		      <el-button size="medium" @click="pdetailinfoDialog=false">取 消</el-button>
		  </div>	                
	  </el-dialog>

          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      ischange:false,
      query: {
          act:'getclerkpercentlists',
          token:this.$cookies.get('token'),
          brandid:'',
          clerkid:'',
          type:'',
          key:'',
          goodstype:'',
          sorttype:1,
          sort:2,
          isexport:0,
          date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
          p:1,
          rollpage:10,
          isexport:0
      },
      percentlistsLoading:false,
      lists:[],
      rows:0,
      brandlists:[],
      clerks:[],
      typelists:[{id:1,name:'线上商城'},{id:2,name:'联营分销'}],
      goodstypelists:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
      sorttypelists:[{id:1,name:'按销售额排序'},{id:2,name:'按提成排序'}],
      sortlists:[{id:1,name:'升序'},{id:2,name:'降序'}],
      goodsmaxheight:{'max-height':'2.5rem','transition':"all .3s",'overflow':'hidden'},
      percentexportDialog:false,
      percentexportLoading:false,
      exportlists:[],
      exporthead:[],
      exportfield:[],
      exportname:'',
      pclerkid:'',
      pdetailDialog:false,
      pdetailLoading:false,
      pdetaillists:[],
      pclerktitle:'',
      
      pdetailinfoDialog:false,
      pdetailinfoLoading:false,
      pclerkinfotitle:'',
      pdetailinfolists:[],
      clerkname:'',
      allsales:0,
      alltc:0,
      
      normaltotals:0,
      normaltc:0,
      normalnumber:0,
      brandtotals:0,
      brandtc:0,
      brandnumber:0,
      goodstotals:0,
      goodstc:0,
      goodsnumber:0,
      normallists:[],
      brandlists:[],
      goodslists:[]

    }  
  },
  mounted(){
      this.getBrand(); //获取品牌信息
	  this.getClerk(); //获取销售员列表信息
      this.getlists(); //获取提成列表信息
  },
  methods:{

      /** 展开、收起搜索条件 **/
      showandclosegoods() {
          if(this.goodsmaxheight['max-height']=='2.5rem') {
              this.goodsmaxheight['max-height']='5.5rem';
          }else {
              this.goodsmaxheight['max-height']='2.5rem';
          }
      },

      /** 获取品牌 **/
	    getBrand(){
	        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		        	var _this=this;
		            var result = JSON.parse(Base64.decode(res.data.Data));
		            this.brandlists=[];
		            result.forEach(function(e,i) {
		            	_this.brandlists.push({id:e.id,name:e.name,py:e.py,showlable:e.showlable});
		            });
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	    },

      //获取销售员列表
      getClerk() {
      	  var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),p:1,rollpage:100000}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
	            }else{
		            this.clerks = JSON.parse(Base64.decode(res.data.Data));
	            }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
      },

      /** 获取提成信息 **/
      getlists() {
          if(this.ischange==true) {
              this.query.p=1;
              this.query.rollpage=10;
          }

          this.percentlistsLoading=true;
          this.query.isexport=0;
          var resource = this.$resource(this.url);
	      resource.save(this.query).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
                  this.percentlistsLoading=false;
	          }else{
		          this.lists = JSON.parse(Base64.decode(res.data.Data));
                  this.rows=parseInt(res.data.count);
                  this.percentlistsLoading=false;
                  if(this.ischange==true) this.ischange=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
              this.percentlistsLoading=false;
	      });
      },

      percentlistspageChange(val) {
        this.query.rollpage = val;
        this.getlists();
      },
      percentlistsCurrentChange(val) {
        this.query.p = val;
        this.getlists();
      },

      
      /** 获取销售商品信息详情 **/
      showpercentdetail(item) {
          this.pdetailDialog=true;
          this.pdetailLoading=true;
          this.pclerkid=item.clerkid;
          this.clerkname=item.clerkname;
          this.pclerktitle='销售员：'+item.clerkname+' 提成信息详情';
          var resource = this.$resource(this.url);
	      resource.save({act:'getclerkpercentdetail',token:this.$cookies.get('token'),brandid:this.query.brandid,clerkid:item.clerkid,type:'',key:this.query.key,goodstype:this.query.goodstype,date:this.query.date}).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
                  this.pdetailLoading=false;
	          }else{
		          this.pdetaillists = JSON.parse(Base64.decode(res.data.Data));
                  this.pdetailLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
              this.pdetailLoading=false;
	      });
      },


      /** 获取月份商品销售信息详情 **/
      showdetailinfos(item) {
          this.allsales=item.realsales;
          this.alltc=item.tcsale;
          this.pdetailinfoDialog=true;
          this.pdetailinfoLoading=true;
          this.pclerkinfotitle='销售员：'+this.clerkname+'提成信息详情（'+item.ptime+")";
          var resource = this.$resource(this.url);
	      resource.save({act:'getclerkpercentdetailinfo',token:this.$cookies.get('token'),brandid:this.query.brandid,clerkid:item.clerkid,type:'',key:this.query.key,goodstype:this.query.goodstype,date:this.query.date,ptime:item.ptime}).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
                  this.pdetailinfoLoading=false;
	          }else{
		          this.pdetailinfolists = JSON.parse(Base64.decode(res.data.Data));
                  //分发处理
                  this.normaltotals=this.pdetailinfolists.normal.total;
                  this.normaltc=this.pdetailinfolists.normal.tc;

                  this.normalnumber=this.pdetailinfolists.normal.lists.length;
                  this.brandtotals=this.pdetailinfolists.brand.total;
                  this.brandtc=this.pdetailinfolists.brand.tc;
                  this.brandnumber=this.pdetailinfolists.brand.lists.length;
                  this.goodstotals=this.pdetailinfolists.goods.total;
                  this.goodstc=this.pdetailinfolists.goods.tc;
                  this.goodsnumber=this.pdetailinfolists.goods.lists.length;

                  this.normallists=this.pdetailinfolists.normal.lists;
                  this.brandlists=this.pdetailinfolists.brand.lists;
                  this.goodslists=this.pdetailinfolists.goods.lists;

                  this.pdetailinfoLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
              this.pdetailinfoLoading=false;
	      });
      },

      
      /** 导出提成信息列表 **/
      exportpercentlists() {
          this.percentexportDialog=true;
          this.percentexportLoading=true;
          this.query.isexport=1;
          var resource = this.$resource(this.url);
	      resource.save(this.query).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
                  this.percentexportLoading=false;
	          }else{
		          this.exportlists = JSON.parse(Base64.decode(res.data.Data));
                  this.percentexportLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
              this.percentexportLoading=false;
	      });
      },

      //导出销售订单详情信息
	  exportpercents() {			
		  this.exporthead=['销售员名称','销售金额','提成金额'];
		  this.exportfield=['clerkname','realsales','tcsale'];
		  this.exportname='销售员提成信息表';
		  this.exportput();
		  this.percentexportDialog=false;	
	  },


	  /** 确认导出信息 **/
	  exportput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var data = this.formatJson(this.exportfield, this.exportlists);
			  export_json_to_excel(this.exporthead, data, this.exportname);
		  })
	  },
		
	  //导出表格数据
	  formatJson(filterVal, jsonData) {
	　　　  return jsonData.map(v => filterVal.map(j => v[j]));
	　}, 

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Mallpercent.vue